module.exports = __webpack_public_path__ + "img/male-avatar.ce040a81.jpg";